<template>
  <div id="cartview" style="background: #fff; border-radius: 20px; padding: 15px 0; color:#000; overflow: hidden; width:100%; box-shadow: 0 2px 4px 0 rgba(0,0,0,.5);">
    <h3 class="text-center cartTitle">Корзина</h3>
    <section v-if="cart.length > 0">
      <div class="fix" style="max-height:45vh; margin:20px 0; overflow-y:scroll;">
        <div class="cart" v-for="product in cart" :key="product.id" style="padding: 0 15px;">
          <div class="bounceIn">
            <div class="row">
              <div class="col-md-10 text-left">
                <p class="angrybirds">{{ product.name }}</p>
              </div>
              <div class="col-md-1" style="padding-left:9px;">
                <i class="fa cursor fa-window-close" @click="del(product.id)"></i>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <i class="fa cursor fa-minus-circle" @click="dec(product.id)"></i>
                <span>{{ qtyInCart(product.id) }} шт.</span>
                <i class="fa fa-plus-circle cursor" @click="inc(product.id)"></i>
              </div>
              <div class="col-md-6">
                <p style="font-family:AngryBirds;"><span class="" style="font-size:20px;">{{ product.price * product.qty }}</span> руб.</p>
              </div>
            </div>
          </div>
          <hr>
        </div>
      </div>
      <div class="row cartBottom" style="padding: 0 15px;">
        <div class="col-md-8 offset-md-4 text-right">
          <p class="angrybirds">Всего: {{ total_in_cart }} <i class="fa fa-ruble-sign"></i></p>
        </div>
        <div class="col-md-12">
          <router-link class="btn btn-buy btn-block" :to="{ name: 'Order'}">Оформить заказ</router-link>
          <!-- <a href="/cart" class="btn btn-buy btn-block">Оформить заказ</a> -->
        </div>
      </div>
    </section>
    <h3 v-if="cart.length == 0" class="text-center" style="padding: 0 15px;">Вы пока ничего не выбрали</h3>
  </div>
</template>

<script>
  import _ from "lodash";

  export default {
    computed: {
      cart() {
        return this.$store.state.cart;
      },
      total_in_cart() {
        return _.sumBy(this.cart, function (product) {
          return product.price * product.qty;
        });
      }
    },
    methods: {
      qtyInCart(id) {
        var found = _.find(this.$store.state.cart, ["id", id]);
        if (typeof found == "object") {
          return found.qty;
        } else {
          return 0;
        }
      },
      inc(id) {
        this.$store.commit({
          type: "inc",
          id
        });
      },
      dec(id) {
        this.$store.commit({
          type: "dec",
          id
        });
      },
      del(id) {
        this.$store.commit({
          type: "del",
          id
        });
      }
    }
  }

</script>



// WEBPACK FOOTER //
// src/components/Home/cart.vue